module.exports = __webpack_public_path__ + "static/media/14UNEP17.6e5a740b.jpg";